import { FaClock, FaClipboardList } from "react-icons/fa";
import Button from "../Button";
import { Link } from "react-router-dom";
import "./style.scss";

const PreparationCard = ({
  title,
  description,
  duration,
  questions,
  subjects = [],
  difficulty,
  buttonLabel = "Start Preparation",
}) => {
  const difficultyColors = {
    Easy: "success",
    Medium: "warning",
    Hard: "danger",
  };

  return (
    <div className="col-md-4 col-12 mb-4">
      <div className="card bg-dark text-light border border-primary h-100 prep-hover">
        <div className="card-body d-flex flex-column">
          {/* Header */}
          <div className="d-flex justify-content-between align-items-start mb-2">
            <h5 className="fw-bold">{title}</h5>
            {difficulty && (
              <span className={`badge bg-${difficultyColors[difficulty]}`}>
                {difficulty}
              </span>
            )}
          </div>

          {description && <p className="text-muted">{description}</p>}

          {/* Meta Info */}
          <div className="d-flex flex-wrap mb-2 small text-muted">
            {duration && (
              <div className="me-3 d-flex align-items-center">
                <FaClock className="me-1" /> {duration} min
              </div>
            )}
            {questions && (
              <div className="d-flex align-items-center">
                <FaClipboardList className="me-1" /> {questions} questions
              </div>
            )}
          </div>

          {/* Subjects */}
          {subjects.length > 0 && (
            <div className="mb-3">
              <span className="fw-bold">Subjects:</span>
              <div className="mt-2">
                {subjects.map((sub, idx) => (
                  <span key={idx} className="badge bg-primary me-2 mb-2">
                    {sub}
                  </span>
                ))}
              </div>
            </div>
          )}

          {/* Button */}
          <Link to={`/placement/${title}`}>
          <Button variant="gradient" fullWidth>
            {buttonLabel}
          </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PreparationCard;
